module.exports = __webpack_public_path__ + "img/logo_vert_short.de5038e3.svg";